import {remCalc} from '../../_utils'

const getStyles = (props: {
    labelPosition: string
    textWidth: string
    textSize: string
    iconSize: string
    width: string
    justifyContent: string
}) => {
    return {
        container: {
            display: 'inline-flex',
            alignItems: props.labelPosition === 'top' ? 'center' : 'start',
            gap: props.textWidth === 'small' ? 0 : remCalc(10),
            flexDirection: props.labelPosition === 'top' ? 'row' : 'column',
            justifyContent: props.justifyContent ? props.justifyContent : 'unset',
            width: props.width ? props.width : 'auto',
        },
        description: {
            width: (() => {
                switch (props.textWidth) {
                    case 'big':
                        return remCalc(148)
                    case 'medium':
                        return remCalc(83)
                    case 'small':
                        return remCalc(73)
                    default:
                        return 'auto'
                }
            })(),
            textStyle: props.textSize === 'big' ? 'body-small' : 'body-xsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        labelIcon: {
            display: 'flex',
            width: props.iconSize === 'big' ? remCalc(67) : remCalc(55),
            height: props.iconSize === 'big' ? remCalc(33) : remCalc(28),
            justifyContent: 'center',
            alignItems: 'center',
        },
        icon: {
            width: props.iconSize === 'big' ? remCalc(67) : remCalc(55),
            height: props.iconSize === 'big' ? remCalc(33) : remCalc(28),
        },
    }
}

export default {
    baseStyle: getStyles,
}
